export default "__VITE_ASSET__DcogbLMN__"